import {
  faAddressBook,
  faAddressCard,
  faBan,
  faBars,
  faBasketballBall,
  faBell,
  faBuilding,
  faCalendarDay,
  faCaretDown,
  faCaretSquareLeft,
  faCaretUp,
  faCertificate,
  faCheck,
  faCheckCircle,
  faCheckDouble,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faClock,
  faCloudDownloadAlt,
  faCog,
  faCommentAlt,
  faCopy,
  faDotCircle,
  faEdit,
  faEnvelope,
  faExclamationTriangle,
  faEye,
  faFileArchive,
  faFileContract,
  faFileCsv,
  faFileExcel,
  faFilePdf,
  faFileSignature,
  faFileUpload,
  faFileWord,
  faFilter,
  faGift,
  faGlobe,
  faHandshake,
  faImage,
  faImages,
  faInfoCircle,
  faLink,
  faLocationArrow,
  faLock,
  faMailBulk,
  faMinus,
  faMoneyBill,
  faMoon,
  faNewspaper,
  faPaperPlane,
  faPaperclip,
  faPauseCircle,
  faPenNib,
  faPhone,
  faPlane,
  faPlaneDeparture,
  faPlus,
  faPlusSquare,
  faQuestionCircle,
  faRedo,
  faRocket,
  faSave,
  faSearch,
  faSignOutAlt,
  faSortAlphaDown,
  faSortAlphaUp,
  faSun,
  faSync,
  faTimes,
  faTrash,
  faTrophy,
  faUnlock,
  faUser,
  faUserAlt,
  faUserClock,
  faUserFriends,
  faUserNinja,
  faUserPlus,
  faUserTie,
  faUsers,
  faUsersCog,
  faWallet,
  faWifi,
} from "@fortawesome/free-solid-svg-icons";

export const icons = {
  add: faPlusSquare,
  accept: faCheck,
  accepted: faCheck,
  active: faCheckCircle,
  audit: faEye,
  authoriser: faUsers,
  authorisingRole: faUsers,
  ban: faBan,
  bars: faBars,
  betaAccess: faRocket,
  chargingPeriod: faMoneyBill,
  brand: faBasketballBall,
  dateRelativeTo: faCalendarDay,
  calendar: faCalendarDay,
  caretDown: faCaretDown,
  caretUp: faCaretUp,
  chat: faCommentAlt,
  chevronDown: faChevronDown,
  chevronLeft: faChevronLeft,
  chevronRight: faChevronRight,
  chevronUp: faChevronUp,
  christmas: faGift,
  client: faBuilding,
  clients: faBuilding,
  clock: faClock,
  close: faTimes,
  consultants: faCertificate,
  contact: faUserPlus,
  contacts: faAddressBook,
  contracts: faFileContract,
  contract: faFileContract,
  contractor: faUser,
  contractors: faUser,
  contractingRole: faUser,
  copy: faCopy,
  cross: faTimes,
  delete: faTrash,
  deleted: faTrash,
  documents: faFileContract,
  dotCircle: faDotCircle,
  download: faCloudDownloadAlt,
  edit: faEdit,
  emailSettings: faMailBulk,
  entryPeriod: faClock,
  envelope: faEnvelope,
  fileCsv: faFileCsv,
  fileExcel: faFileExcel,
  fileZip: faFileArchive,
  filter: faFilter,
  financials: faMoneyBill,
  help: faQuestionCircle,
  holiday: faPlane,
  information: faInfoCircle,
  invite: faPaperPlane,
  link: faLink,
  lock: faLock,
  logo: faImage,
  logos: faImages,
  logout: faSignOutAlt,
  search: faSearch,
  minus: faMinus,
  moon: faMoon,
  name: faFileSignature,
  navigationBack: faCaretSquareLeft,
  nightshift: faMoon,
  newsFeed: faNewspaper,
  paperPlane: faPaperPlane,
  paperclip: faPaperclip,
  passwordReset: faUnlock,
  pdf: faFilePdf,
  pen: faPenNib,
  pending: faClock,
  personalRole: faHandshake,
  planeDeparture: faPlaneDeparture,
  plus: faPlus,
  processed: faCheckDouble,
  rainbow: faPenNib,
  recruitmentAgency: faUserTie,
  recruitmentAgencyAdministrationRole: faUserFriends,
  recruitmentAgencySuperAdministrationRole: faUserNinja,
  recruitmentAgencySettings: faCog,
  redo: faRedo,
  refresh: faSync,
  reject: faTimes,
  rejected: faTimes,
  remind: faPaperPlane,
  reminders: faBell,
  role: faUserAlt,
  roles: faAddressCard,
  save: faSave,
  settings: faCog,
  primaryAuthoriser: faTrophy,
  signupEmail: faUserPlus,
  sortAlphaDown: faSortAlphaDown,
  sortAlphaUp: faSortAlphaUp,
  submitted: faPaperPlane,
  telephone: faPhone,
  tick: faCheck,
  timesheet: faUserClock,
  timesheets: faUserClock,
  timesheetEntries: faUserClock,
  timesheetsUrl: faLocationArrow,
  upload: faFileUpload,
  user: faUser,
  userSettings: faUsersCog,
  waiting: faPauseCircle,
  warning: faExclamationTriangle,
  website: faGlobe,
  weekday: faSun,
  word: faFileWord,
  timeline: {
    clock: faClock,
  },
  wallet: faWallet,
  wifi: faWifi,
};
